<!--
 * @Overview:   AssessmentResult
 * @Author:     Zi_Jun
 * @Email:      zijun2030@163.com
 * @Date:       2020/7/14 11:46
 * @Mark:
 -->

<template>
  <div class="assessment-result-wrap">
    <Progress progress="52"></Progress>
    <div
      v-if="resultData"
      :class="{ 'no-scroll': popUpVisible }"
      class="assessment-result"
    >
      <div class="part-1 van-hairline--bottom">
        <p class="common-text">{{ $t("assessment.result.domText[0]") }}</p>
        <p class="number-text">
          {{ (resultData && resultData.score) || "--" }}
        </p>
        <p class="common-text left">{{ $t("assessment.result.domText[1]") }}</p>
<!--        <p class="mark-text right">{{ $t("assessment.result.domText[2]") }}</p>-->
      </div>
      <div class="part-2">
        <p class="common-text">{{ $t("assessment.result.domText[3]") }}</p>
        <div class="primary-content" :class="[lang]">
          <div class="primary-text">
            {{ (resultData && resultData.type) || "--" }}
            <p class="sub-text">{{ $t("assessment.result.domText[4]") }}</p>
          </div>
        </div>
        <p class="warn-text">
          {{ $t("assessment.result.domText[5]")
          }}<span class="high-light-text">{{
            (resultData && resultData.risk_tolerance) || "--"
          }}</span>
        </p>
      </div>
      <div class="part-3">
        {{ resultData && resultData.title }}
      </div>
    </div>
    <div
      v-if="!resultData && requestFail"
      class="net-error"
      @click="getRiskResultData"
    >
      <van-empty :image="IMG_NET_ERR" class="net-error-image has-gap">
        <p class="error-text">{{ $t("public.contentText[5]") }}</p>
      </van-empty>
    </div>
    <nav-buttons @on-next="handNext"></nav-buttons>
  </div>
</template>

<script>
import { Empty, Toast } from "vant";
import { getBrowser } from "@/utils/browser";
import navButtons from "../components/navButtons.vue";
import Progress from "../components/Progress.vue";

export default {
  components: {
    VanEmpty: Empty,
    Progress,
    navButtons
  },
  data() {
    return {
      isAPP: getBrowser().isApp,
      resultData: null,
      popUpVisible: false,
      textContent: [],
      requestFail: false,
      IMG_NET_ERR: this.IMG_NET_ERR,
      process_id: "",
      lang:''
    };
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    }
  },
  created() {
    this.init();
    this.handDetail();
    this.resultData = null;
    this.popUpVisible = false;
    this.lang = localStorage.getItem('localLang');
  },
  methods: {
    init() {
      this.textContent = this.$t("assessment.result.textContent");
    },
    async handDetail() {
      const params = {
        step_code:'1'
      }
      await this.$apis.accountSituationV2(params).then(res => {
        if (res.process_info) {
          this.process_id = res?.process_info["1"]?.process_id;
        }
      });
      this.$nextTick(() => {
        this.getRiskResultData();
      });
    },
    getRiskResultData() {
      const params = {
        process_id: this.process_id,
        step_code: "8-2",
        step_order: 8
      };
      this.$apis
        .getAccountRiskResultApi(params)
        .then(res => {
          this.requestFail = false;
          if (Object.keys(res).length == 0) {
            this.$router.push({ path: "/open-account/riskQuestionnaire" });
          } else {
            this.resultData = res;
          }
        });
    },
    handNext() {
      const params = {
        process_id: this.process_id,
        step_code: "8-2",
        step_order: 8,
        config_data: {}
      };
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis
        .supplementSaveApi(params)
        .then((res) => {
          if (res) {
            this.$router.push({
              path: "/open-account/exemptedCustomers",
              query:{
                ...this.$route.query
              }
            }).finally(() => {
              toastLoading.clear();
            });
          }
        });
    }
  }
};

</script>

<style lang="less" scoped>
@lightColor: #ff9275;
@white: #fff;
@grey-4: #444;
@grey-8: #888;
.assessment-result {
  .part-1 {
    padding: 20px 20px 0;
    height: 100px;
    display: flex;
    align-items: center;
    background: @white;
    margin-top: 60px;

    .left {
      margin-right: auto;
    }

    .right {
      margin-left: auto;
    }

    .common-text {
      font-size: 36px;
      line-height: 36px;
      color: #17161C;
      font-weight: 500;
    }

    .number-text {
      padding: 0 16px 0 16px;
      font-size: 60px;
      line-height: 48px;
      color: #17161C;
      font-weight: 500;
    }

    .mark-text {
      font-size: 28px;
      line-height: 40px;
      color: @grey-8;
    }
  }

  .part-2 {
    height: 380px;
    background: @white;

    .common-text {
      padding: 26px 0 0 20px;
      font-size: 32px;
      line-height: 48px;
      color: #17161C;
      font-weight: 500;
    }

    .primary-content {
      display: flex;
      //justify-content: center;
      //align-items: center;
      margin-left: 25%;
      margin-top: 78px;

      .primary-text {
        position: relative;
        font-size: 76px;
        line-height: 64px;
        font-weight: 500;
        color: #17161C;
      }

      .sub-text {
        position: absolute;
        right: -180px;
        bottom: 0px;
        width: 160px;
        top: 14px;
        font-size: 40px;
        line-height: 64px;
        color: #17161C;
        font-weight: 500;
      }
    }

    .warn-text {
      display: flex;
      justify-content: center;
      margin-top: 32px;
      font-size: 32px;
      font-weight: 500;
      line-height: 48px;
      color: #17161C;
      .high-light-text {
        padding-left: 12px;
        color: #F24E1E;
      }
    }
  }

  .part-3 {
    font-size: 28px;
    color: #747377;
    background: #F6F7FA;
    margin-left: 32px;
    margin-right: 32px;
    border-radius: 24px;
    font-weight: 400;
    padding: 40px 32px 40px 32px;
    position: relative;
  }
  .part-3::after{
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    /* 箭头靠右边 skewY(50deg)和skewY(-50deg)可以调节箭头方向*/
    left: 10%;
    bottom: -34px;
    border-left: 10px solid transparent;
    border-right: 15px solid transparent;
    border-top: 44px solid #F6F7FA;
    transform: skewX(-5deg);
  }

  .part-4 {
    padding: 20px 50px;
  }

  .part-5 {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    font-size: 28px;
    line-height: 40px;
    color: @grey-4;
  }

  .part-6 {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 20px 90px;
    background: rgba(68, 68, 68, 0.5);

    .content {
      width: 100%;
      height: 100%;
      overflow: auto;
      border-radius: 8px;
      background: #fff;
    }

    .title {
      height: 88px;
      position: fixed;
      width: 710px;
      top: 20px;
      left: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      line-height: 44px;
      color: @white;
      background: #1c0955;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    .tips {
      position: fixed;
      width: 690px;
      padding: 8px 10px;
      top: 108px;
      left: 20px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #eee;
      font-size: 24px;
      line-height: 34px;
      color: @grey-8;
    }

    .main-text {
      padding: 178px 20px 30px 20px;
      background: @white;

      .text-item {
      }

      .item-title {
        padding-bottom: 20px;
        display: flex;
        justify-content: center;
        font-size: 32px;
        line-height: 44px;
        color: @grey-4;
      }

      .item-text {
        font-size: 28px;
        line-height: 40px;
        color: @grey-8;
        margin-bottom: 40px;
      }
    }

    .button {
      padding: 0 50px 40px 50px;
      background: #fff;
    }

    .btn-text {
      display: flex;
      justify-content: center;
      padding-bottom: 40px;
      background: #fff;
    }
  }

  .is-in-h5 {
    top: 100px;

    .title {
      top: 120px;
    }

    .tips {
      top: 208px;
    }
  }
}

.no-scroll {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}

@black: #1B1C24;
.black-theme {
  background-color: @black;
  min-height: 100%;
  color: #fff;

  .assessment-result .part-1 {
    background-color: @black;
    color: #fff;
  }

  .assessment-result .part-1 .common-text {
    color: #fff;
  }

  .assessment-result .part-2 {
    background-color: @black;
    color: #fff;
  }

  .assessment-result .part-2 .common-text {
    color: #fff;
  }

  .assessment-result .part-2 .primary-content {
    color: #fff;

    .primary-text {
      color: #fff;
    }

    .sub-text {
      color: #fff;
    }
  }

  .assessment-result .part-3 {
    background-color: @black;
    color: #fff;
  }

  .assessment-result .part-5 {
    background-color: @black;
    color: #fff;
  }

  .assessment-result .part-6 {
    background-color: @black;
    color: #fff;

    .content {
      background-color: @black;
      color: #fff;
    }

    .tips {
      background-color: @black;
      color: #fff;
    }

    .button {
      background-color: @black;
      color: #fff;
    }

    .btn-text {
      background-color: @black;
      color: #fff;
    }

    .main-text {
      background-color: @black;
      color: #fff;

      .item-title {
        color: #fff;
      }

      .item-text {
        color: #fff;
      }
    }
  }

  /deep/ .van-button--normal {
    background-color: #377CFB !important;
    border-color: #377CFB !important;
  }
}

.black-theme{
  .assessment-result-wrap{
    .part-1{
      .number-text{
        color: #FFFFFF;
      }
    }
    .part-2{
      .warn-text{
        color: #FFFFFF;
      }
    }
    .part-3{
      background: #14151D;
    }
    .part-3::after{
      /* 箭头靠右边 skewY(50deg)和skewY(-50deg)可以调节箭头方向*/
      border-left: 10px solid transparent;
      border-right: 15px solid transparent;
      border-top: 44px solid #14151D;
    }
  }
}
.en{
  margin-left: 20% !important;
}
</style>
